function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2307 11.7508H20.5606C19.8526 11.7508 19.1615 12.0401 18.6646 12.5444L11.1554 20.165H8.74196C8.13602 20.165 7.56837 20.403 7.14341 20.835C6.7186 21.2671 6.49021 21.8388 6.50032 22.445C6.5206 23.6603 7.53841 24.6489 8.76922 24.6489H12.1174C12.8254 24.6489 13.5165 24.3597 14.0135 23.8554L21.5227 16.2347H24.258C24.8638 16.2347 25.4316 15.9967 25.8565 15.5647C26.2813 15.1328 26.5097 14.561 26.4996 13.9547C26.4793 12.7395 25.4615 11.7508 24.2307 11.7508Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1053 7.35105C14.1545 7.35105 13.3809 8.12464 13.3809 9.0755C13.3809 10.0264 14.1545 10.8 15.1053 10.8C16.0562 10.8 16.8298 10.0264 16.8298 9.07554C16.8298 8.12468 16.0562 7.35105 15.1053 7.35105Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1423 11.2465C14.1737 11.2299 13.3809 12.0395 13.3809 13.0083V16.463L16.8435 12.9776C16.8435 12.033 16.0831 11.2627 15.1423 11.2465Z",
  fill: "black"
});

function SvgIconEscalatorInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEscalatorInactive);
export default __webpack_public_path__ + "static/media/icon_escalator_inactive.9786719d.svg";
export { ForwardRef as ReactComponent };